export { renderTagPickerButton_unstable as renderTagPickerButton } from '@fluentui/react-tag-picker';
